import request from '../../libs/request';

export default {
  getOrders: (federalDocument, siteId) => request(`api/v1/${siteId}/totem/search/${federalDocument}`).get(),

  getOrder: (hash, siteId) => request(`api/v1/${siteId}/totem/search/order/${hash}/pagamento`).get(),

  getConfirmation: (hash, siteId) => request(`api/v1/${siteId}/totem/order/${hash}/confirmacao`).get(),

  sendPaymentOrder: (hash, body, siteId) => request(`api/v1/${siteId}/totem/order/${hash}/payment`).post({ body }),
};
